import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../style.css';
import Purchase from './modal/Purchase';

function ResultReport({ filters, keyword }) {
    const [reports, setReports] = useState([]);
    const [filteredReports, setFilteredReports] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedReport, setSelectedReport] = useState(null);
    const [loading, setLoading] = useState(true);
    const [purchasedReport, setPurchasedReport] = useState([]);
    const [sortOrder, setSortOrder] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchReports = async () => {
            try {
                const response = await axios.get('https://geoid-rest.vercel.app/paper_report');
                const publicReports = response.data.filter(report => report.access === 'public');
                setReports(publicReports);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching report data:', error);
                setLoading(false);
            }
        };

        fetchReports();
    }, []);

    useEffect(() => {
        const fetchUserPurchase = async () => {
            try {
                setLoading(true); // Start loading
                const user = JSON.parse(localStorage.getItem('user'));
                const response = await axios.get(`https://geoid-rest.vercel.app/users/${user.user._id}`);
                setPurchasedReport(response.data.reports);
            } catch (error) {
                console.error("There was an error fetching the reports!", error);
            } finally {
                setLoading(false);
            }
        };

        fetchUserPurchase();
    },[])

    useEffect(() => {
        let filtered = reports;

        // if (filters.country) {
        //     filtered = filtered.filter(report => report.country?.toLowerCase() === filters.country.toLowerCase());
        // }
        if (filters.state) {
            filtered = filtered.filter(report => report.state?.toLowerCase() === filters.state.toLowerCase());
        }
        if (filters.category === 'geology') {
            filtered = filtered.filter(report => report.category?.toLowerCase().startsWith('g'));
        }
        if (filters.category === 'archaeology') {
            filtered = filtered.filter(report => report.category?.toLowerCase().startsWith('a'));
        }
        if (filters.discipline) {
            console.log(filtered)
            filtered = filtered.filter(report => report.category?.toLowerCase() === filters.discipline.toLowerCase());
        }
        if (filters.majorLithology) {
            filtered = filtered.filter(report => report.majorLithology?.toLowerCase() === filters.majorLithology.toLowerCase());
        }
        if (filters.rockType) {
            filtered = filtered.filter(report => report.rockType?.toLowerCase() === filters.rockType.toLowerCase());
        }
        if (filters.formation) {
            filtered = filtered.filter(report => report.formation?.toLowerCase() === filters.formation.toLowerCase());
        }
        if (filters.age) {
            filtered = filtered.filter(report => report.age?.toLowerCase() === filters.age.toLowerCase());
        }

        if (keyword) {
            const keywordLower = keyword.toLowerCase();
            filtered = filtered.filter(report =>
                report.title.toLowerCase().includes(keywordLower) ||
                report.author.toLowerCase().includes(keywordLower) ||
                report.category.toLowerCase().includes(keywordLower) ||
                report.tags.some(tag => tag.toLowerCase().includes(keywordLower))
            );
        }

        setFilteredReports(filtered);
    }, [filters, keyword, reports]);

    const sortReports = (items) => {
        if (!sortOrder) return items; // Return unsorted items if sortOrder is null
        return [...items].sort((a, b) => {
            const titleA = a.title.toLowerCase();
            const titleB = b.title.toLowerCase();
            if (sortOrder === 'asc') {
                return titleA.localeCompare(titleB);
            } else {
                return titleB.localeCompare(titleA);
            }
        });
    };

    const sortedReports = sortReports(filteredReports);

    const handlePurchaseClick = (report) => {
        navigate('/reports');
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedReport(null);
    };

    if (loading) {
        return <div className="loading-message">Loading data...</div>; // Display loading message
    }

    const handleNavigate = (reportId) => {
        window.open(`/html/${reportId}`, '_blank'); // Open in a new tab
    };

    const handleSortToggle = () => {
        setSortOrder(prevOrder => (prevOrder === 'asc' ? 'desc' : 'asc'));
    };

    return (
        <div className="artifacts-result-page">
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <p style={{ textAlign: 'left' }}>
                    Reports: {sortedReports.length} result{sortedReports.length !== 1 ? 's' : ''} found
                </p>
                <button className='sortBy' onClick={handleSortToggle}>
                    Sort By Alphabet {
                        sortOrder === 'asc' ? 
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-down" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1"/>
                        </svg> : 
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-up" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5"/>
                        </svg>
                    }
                </button>
            </div>
            <div className="reportsResult-list">
                {sortedReports.map((report, index) => (
                    <div className="reportResult-card" key={index}>
                        <div>
                            <h3 className="report-title">{report.title}</h3>
                            <p className="report-description">{report.author} • {report.year} • {report.linkSource}</p>
                            <p className="report-description">{report.description}</p>
                            <div className="report-tags">
                                {report.tags.map((tag, idx) => (
                                    <span className="report-tag" key={idx}>{tag}</span>
                                ))}
                            </div>
                        </div>
                        <div className='report-download'>
                        {purchasedReport.includes(report._id) ? (
                            <a href={report.file} download={report.file} style={{ textDecoration: 'none' }}>
                                <p className='download-button'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-file-earmark-pdf-fill" viewBox="0 0 16 16">
                                        <path d="M5.523 12.424q.21-.124.459-.238a8 8 0 0 1-.45.606c-.28.337-.498.516-.635.572l-.035.012a.3.3 0 0 1-.026-.044c-.056-.11-.054-.216.04-.36.106-.165.319-.354.647-.548m2.455-1.647q-.178.037-.356.078a21 21 0 0 0 .5-1.05 12 12 0 0 0 .51.858q-.326.048-.654.114m2.525.939a4 4 0 0 1-.435-.41q.344.007.612.054c.317.057.466.147.518.209a.1.1 0 0 1 .026.064.44.44 0 0 1-.06.2.3.3 0 0 1-.094.124.1.1 0 0 1-.069.015c-.09-.003-.258-.066-.498-.256M8.278 6.97c-.04.244-.108.524-.2.829a5 5 0 0 1-.089-.346c-.076-.353-.087-.63-.046-.822.038-.177.11-.248.196-.283a.5.5 0 0 1 .145-.04c.013.03.028.092.032.198q.008.183-.038.465z"/>
                                        <path fillRule="evenodd" d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m5.5 1.5v2a1 1 0 0 0 1 1h2zM4.165 13.668c.09.18.23.343.438.419.207.075.412.04.58-.03.318-.13.635-.436.926-.786.333-.401.683-.927 1.021-1.51a11.7 11.7 0 0 1 1.997-.406c.3.383.61.713.91.95.28.22.603.403.934.417a.86.86 0 0 0 .51-.138c.155-.101.27-.247.354-.416.09-.181.145-.37.138-.563a.84.84 0 0 0-.2-.518c-.226-.27-.596-.4-.96-.465a5.8 5.8 0 0 0-1.335-.05 11 11 0 0 1-.98-1.686c.25-.66.437-1.284.52-1.794.036-.218.055-.426.048-.614a1.24 1.24 0 0 0-.127-.538.7.7 0 0 0-.477-.365c-.202-.043-.41 0-.601.077-.377.15-.576.47-.651.823-.073.34-.04.736.046 1.136.088.406.238.848.43 1.295a20 20 0 0 1-1.062 2.227 7.7 7.7 0 0 0-1.482.645c-.37.22-.699.48-.897.787-.21.326-.275.714-.08 1.103"/>
                                    </svg>
                                    &nbsp;PDF
                                </p>
                            </a>
                        ) : null}

                            <a onClick={() => handleNavigate(report._id)} style={{ textDecoration: 'none' }}>
                                <p className='download-button'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-filetype-html" viewBox="0 0 16 16">
                                        <path fillRule="evenodd" d="M14 4.5V11h-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zm-9.736 7.35v3.999h-.791v-1.714H1.79v1.714H1V11.85h.791v1.626h1.682V11.85h.79Zm2.251.662v3.337h-.794v-3.337H4.588v-.662h3.064v.662zm2.176 3.337v-2.66h.038l.952 2.159h.516l.946-2.16h.038v2.661h.715V11.85h-.8l-1.14 2.596H9.93L8.79 11.85h-.805v3.999zm4.71-.674h1.696v.674H12.61V11.85h.79v3.325Z"/>
                                    </svg>
                                    &nbsp;HTML
                                </p>
                            </a>
                            <p className='download-button' onClick={() => handlePurchaseClick(report)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-cash-stack" viewBox="0 0 16 16">
                                    <path d="M1 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1zm7 8a2 2 0 1 0-2-2 2 2 0 0 0 2 2zM7 1.5v1h2v-1H7zm-5 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1zm0 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1zm0 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1z"/>
                                </svg>
                                &nbsp;Purchase
                            </p>
                        </div>
                    </div>
                ))}
            </div>
            {showModal && (
                <Purchase 
                    showModal={showModal} 
                    onClose={handleCloseModal} 
                    report={selectedReport}
                    purchasedReport={purchasedReport}
                />
            )}
        </div>
    );
}

export default ResultReport;